import { getApiClient } from 'adapter/out/client/apiClient';
import StoredAnalysis from 'domain/entity/storedAnalysis';
import UpdateStarStoredAnalysisCriteria from 'use-case/storedAnalysis/update/star/updateStarStoredAnalysisCriteria';

const updateStarStoredAnalysisApiClient = getApiClient(
    (criteria: UpdateStarStoredAnalysisCriteria) => `dashboards/stored-analyses/${criteria.id}/star`,
    StoredAnalysis,
    (criteria: UpdateStarStoredAnalysisCriteria) => ({
        method: 'POST',
        body: JSON.stringify({ starred: criteria.starred }),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default updateStarStoredAnalysisApiClient;
